<template>
  <div class="lightbox" @click="openLightbox">
    <div v-if="image" class="lightbox__media">
      <img v-if="image" :src="image" alt="Akan SMB" />
      <div
        class="lightbox-overlay"
        v-body-scroll-lock="isOpen"
      >
        <div class="lightbox-overlay__close" @click="closeLightbox"></div>
        <img :src="image" alt="Akan SMB" />
      </div>
    </div>
    <div v-else-if="video" class="lightbox__media lightbox__media--video">
      <img
        v-if="video"
        :src="video.cover"
        class="lightbox__poster"
        alt="Akan SMB"
      />
      <div class="lightbox-overlay" v-body-scroll-lock="isOpen">
        <div class="lightbox-overlay__close" @click="closeVideo"></div>
        <video
          playsinline
          :src="video.url"
          @ended="closeVideo()"
          crossorigin="anonymous"
        >
          <track :src="video.subtitles" default kind="subtitles" label="Norsk" srclang="no">
        </video>
      </div>
    </div>
  </div>
</template>

<script>
function changeProperties(overlay, properties) {
  overlay.style.height = properties.height + "px";
  overlay.style.width = properties.width + "px";
  overlay.style.left = properties.left + "px";
  overlay.style.top = properties.top + "px";
}

export default {
  name: "Lightbox",
  props: {
    wasPlayedEarlier: Boolean,
    messages: Array,
    image: String,
    video: Object
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    closeVideoBySwiping() {
      this.closeVideo();
    },
    closeLightboxBySwiping() {
      this.closeLightbox();
    },
    openLightbox(e) {
      e.preventDefault();
      e.stopPropagation();
      if (!this.isOpen) {
        const overlay = this.$el.querySelector(".lightbox-overlay");
        const properties = this.$el.getBoundingClientRect();
        changeProperties(overlay, properties);
        overlay.classList.add("lightbox-overlay--active");
        overlay.classList.add("lightbox-overlay--transition");
        this.isOpen = true;

        if (this.video) {
          var playPromise = overlay.querySelector("video").play();

          if (playPromise !== undefined) {
            playPromise
              .then()
              .catch(function(error) {
                console.log(error)
              });
          }
        }

        document
          .querySelector(".chat-page__wrapper")
          .classList.add("chat-page__wrapper--lightbox");
      }
    },
    closeLightbox(e) {
      if (e) e.stopPropagation();
      const overlay = this.$el.querySelector(".lightbox-overlay");
      const properties = this.$el.getBoundingClientRect();
      changeProperties(overlay, properties);
      overlay.classList.remove("lightbox-overlay--active");
      this.isOpen = false;

      if (this.video) {
        overlay.querySelector("video").pause();
        overlay.querySelector("video").currentTime = 0;
      }

      document
        .querySelector(".chat-page__wrapper")
        .classList.remove("chat-page__wrapper--lightbox");
    },
    closeVideo(e) {
      const chat = this.$store.getters.getChatById(this.$route.params.id);
      this.closeLightbox(e);

      if (!this.wasPlayedEarlier) {
        this.$processMessages(chat.script, chat, this.$store);
        this.$store.dispatch("videoWatched", {
          showNotification: !chat.script.length ? true : false,
          chat: chat
        });
      }
    }
  }
};
</script>

<style lang="scss">
.lightbox {
  position: relative;
  display: block;
  width: 100%;

  &__media {
    background: #dedee2;
    position: relative;
    display: block;
    font-size: 0;
    width: 100%;
    height: 400px;

    img,
    svg,
    video {
      object-fit: cover;
      height: 100%;
      width: 100%;
      left: 0;
      top: 0;
    }

    &--video {
      position: relative;
      max-height: 440px;
      height: 90vw;

      img,
      svg,
      video {
        filter: blur(5px);
        height: 100%;
      }

      &:before {
        content: "";
        background: url("../assets/images/play.svg") no-repeat center;
        transform: translate(-50%, -50%);
        background-size: cover;
        position: absolute;
        font-size: 0;
        height: 45px;
        width: 45px;
        z-index: 1;
        left: 50%;
        top: 50%;
      }
    }
  }

  .lightbox-overlay {
    visibility: hidden;
    position: absolute;
    background: #000;
    height: 100%;
    width: 100%;
    opacity: 0;
    left: 0px;
    top: 0px;

    &__close {
      position: absolute;
      opacity: 0.75;
      height: 40px;
      width: 40px;
      right: 15px;
      z-index: 1;
      top: 15px;

      &:before,
      &:after {
        content: "";
        background-color: $txt-color-alt;
        border-radius: 99999px;
        position: absolute;
        height: 4px;
        width: 80%;
        left: 50%;
        top: 50%;
      }

      &:before {
        transform: translate(-50%, -50%) rotate(-45deg);
      }

      &:after {
        transform: translate(-50%, -50%) rotate(45deg);
      }
    }

    img,
    svg,
    video {
      filter: none;
      position: relative;
      height: 100%;
      width: auto;
      margin: 0 auto;
      left: 50%;
      -webkit-transform: translateX(-50%);
      -ms-transform: translateX(-50%);
      transform: translateX(-50%);
    }

    &--transition {
      @include transition(all, 0.4s);
      position: fixed !important;
    }

    &--active {
      visibility: visible !important;
      height: 100% !important;
      width: 100% !important;
      opacity: 1 !important;
      left: 0 !important;
      top: 0 !important;
      z-index: 999999;

      img,
      svg,
      video {
        border-radius: 0 !important;
      }

      video {
        max-width: 100vw;
      }
    }
  }
}
</style>
